import React from 'react'
import PropTypes from 'prop-types'
import {Input} from "antd"

SingleInput.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    validate: PropTypes.string,
    type: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

function SingleInput(props) {
    function _handleChangeInput(e) {
        const {value} = e.target
        const {onChange} = props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    const {label, placeholder, name, value, validate, type} = props

    return (
        <div className="SingleInput">
            <label htmlFor="priority">{label} <span className='Required'>*</span></label>
            <Input type={type} className={(!!validate && validate.length > 0) ? 'Error' : ''} name={name}
                   value={value} placeholder={placeholder} onChange={_handleChangeInput}/>
            {
                !!validate && validate.length > 0 && <small className="Validate">{validate}</small>
            }

        </div>
    )
}

export default SingleInput